/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Generate_FixturesInputs */

const th_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างตารางแข่ง`)
};

const en_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate fixtures`)
};

const ja_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対戦表を作成`)
};

const zh_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成赛程`)
};

const es_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar calendario`)
};

const pt_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar tabela`)
};

const id_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat jadwal`)
};

const fr_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer le calendrier`)
};

const tl_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bumuo ng iskedyul`)
};

const vi_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo lịch thi đấu`)
};

const ko_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일정 생성`)
};

const de_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielplan erzeugen`)
};

const ru_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Составить расписание`)
};

const tr_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fikstür oluştur`)
};

const it_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera il calendario`)
};

const pl_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wygeneruj terminarz`)
};

const uk_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скласти розклад`)
};

const hi_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम बनाएँ`)
};

const ar_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء الجدول`)
};

const ms_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jana jadual`)
};

const bn_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সূচি তৈরি করুন`)
};

const zh_tw2_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`產生賽程`)
};

const zh_hk2_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`產生賽程`)
};

const ur_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شیڈول بنائیں`)
};

const fa_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ساختن برنامه`)
};

const sw_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tengeneza ratiba`)
};

const nl_generate_fixtures = /** @type {(inputs: Generate_FixturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema genereren`)
};

/**
* | output |
* | --- |
* | "Generate fixtures" |
*
* @param {Generate_FixturesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const generate_fixtures = /** @type {((inputs?: Generate_FixturesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Generate_FixturesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_generate_fixtures(inputs)
	if (locale === "ja") return ja_generate_fixtures(inputs)
	if (locale === "zh") return zh_generate_fixtures(inputs)
	if (locale === "es") return es_generate_fixtures(inputs)
	if (locale === "pt") return pt_generate_fixtures(inputs)
	if (locale === "id") return id_generate_fixtures(inputs)
	if (locale === "fr") return fr_generate_fixtures(inputs)
	if (locale === "tl") return tl_generate_fixtures(inputs)
	if (locale === "vi") return vi_generate_fixtures(inputs)
	if (locale === "ko") return ko_generate_fixtures(inputs)
	if (locale === "de") return de_generate_fixtures(inputs)
	if (locale === "ru") return ru_generate_fixtures(inputs)
	if (locale === "tr") return tr_generate_fixtures(inputs)
	if (locale === "it") return it_generate_fixtures(inputs)
	if (locale === "pl") return pl_generate_fixtures(inputs)
	if (locale === "uk") return uk_generate_fixtures(inputs)
	if (locale === "hi") return hi_generate_fixtures(inputs)
	if (locale === "ar") return ar_generate_fixtures(inputs)
	if (locale === "ms") return ms_generate_fixtures(inputs)
	if (locale === "bn") return bn_generate_fixtures(inputs)
	if (locale === "zh-TW") return zh_tw2_generate_fixtures(inputs)
	if (locale === "zh-HK") return zh_hk2_generate_fixtures(inputs)
	if (locale === "ur") return ur_generate_fixtures(inputs)
	if (locale === "fa") return fa_generate_fixtures(inputs)
	if (locale === "sw") return sw_generate_fixtures(inputs)
	if (locale === "nl") return nl_generate_fixtures(inputs)
	return en_generate_fixtures(inputs)
});